const ClassificationTypeFilter = ({ data, onChangeHandler, isDownload }) => {
  const handleCheckboxChange = (index, event) => {
    event.stopPropagation();
    onChangeHandler(index);
  };

  return (
    <div onClick={(e) => e.stopPropagation()} className="request-center-modal">
      <div className={`form-check ${isDownload ? "" : "ml-3"}`}>
        {data.map((item, index) => (
          <div key={index} className="tw-flex tw-items-center tw-py-2 tw-px-2">
            <input onChange={(e) => handleCheckboxChange(index, e)} className="form-check-input mt-0" type="checkbox" value={item.name} checked={item.isChecked} name={item.name} id={item.name} />
            <label className={`form-check-label ${isDownload ? "pl-4" : ""}`} htmlFor={item.name}>
              {item.name}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ClassificationTypeFilter;
